import React, { useEffect } from 'react';
import { hydrateRoot } from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { UserProvider } from './UserContext';
import { PriceProvider } from './client/Components/Context/PriceContext.js';

import './index.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import '@fortawesome/fontawesome-free/css/all.min.css';
const API_URL = process.env.REACT_APP_API_URL;

const rootElement = document.getElementById('root');

if (rootElement) {
  const RootApp = () => {
    useEffect(() => {
      if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator) {
        navigator.serviceWorker.register('/service-worker.js')
          .then(registration => {
            console.log('SW registered:', registration);
          })
          .catch(error => {
            console.log('SW registration failed:', error);
          });
      }
      // Check for updates every hour
      setInterval(() => {
        fetch(`${API_URL}/api/data/version.json`)
          .then(res => res.json())
          .then(data => {
            if (data.version !== process.env.REACT_APP_VERSION) {
              console.log('New version detected - refreshing');
              window.location.reload(true);
            }
          });
      }, 3600000); // 1 hour

      // Tell service worker to check version
      if ('serviceWorker' in navigator) {
        navigator.serviceWorker.controller?.postMessage({
          type: 'CHECK_VERSION',
          clientVersion: process.env.REACT_APP_VERSION
        });
      }
    }, []);

    return <App />;
  };

  hydrateRoot(
  rootElement,
  <Router>
    <UserProvider>
      <PriceProvider>
        <RootApp />
      </PriceProvider>
    </UserProvider>
  </Router>
);

}

reportWebVitals();
